import React from 'react'

import Roletypes from "./Roletypes"
import SocialIcons from './SocialIcons'
import ProfileLinks from './ProfileLinks'

const CardProfile = () => {
    return (
        <div className="card-started" id="home-card">


            <div className="profile no-photo">


                <div className="slide profile-photo" ></div>


                <div className="title">Piyush Talele</div>

                <Roletypes />

                <SocialIcons />

                <ProfileLinks />

            </div>

        </div>
    );
}

export default CardProfile;